import React, { useEffect, useState } from "react";
import {
  Link,
  Box,
  Typography,
  Tooltip,
  Modal,
  IconButton,
  Button,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import InfoIcon from "@mui/icons-material/Info";

export function SpeechConfigCard({ data }) {
  const user = JSON.parse(localStorage.getItem("user"));

  return (
    <Box
      sx={{
        borderRadius: "10px",
        background: "var(--mui-palette-gray-lightGray50)",
        boxShadow: "0 5px 10px rgba(0, 0, 0, 0.1)",
        maxWidth: "400px",
        padding: "15px 5px 5px 15px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        transition: "all .5s ease-in-out",
        position: "relative",
        overflow: "hidden",
        "&:hover": {
          background: "var(--mui-palette-primary-blue)",
          boxShadow: "0 20px 40px rgba(61,65,84,.15)",
          transform: "translateY(-2px)",
          transition: "all .5s ease-in-out",
          "& h6, & a, & .MuiSvgIcon-root, & .MuiBox-root": {
            color: "var(--mui-palette-common-white)",
          },
        },
        "&::before": {
          content: '""',
          display: "block",
          height: "5px",
          width: 0,
          position: "absolute",
          left: 0,
          top: 0,
          backgroundColor: "var(--mui-palette-primary-orange)",
          transition: "all .5s ease-in-out",
        },
        "&:hover:before": {
          width: "100%",
        },
        "& > *": {
          position: "relative",
          zIndex: 1,
        },
      }}
    >
      <Box>
        <Typography
          color="common.black"
          align="left"
          variant="h6"
          sx={{
            fontSize: "1rem",
            lineHeight: 1.4,
            minHeight: "40px",
            fontWeight: "bold",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2,
            overflow: "hidden",
            textOverflow: "ellipsis",
            paddingRight: "50px",
          }}
        >
          Geographical Type
        </Typography>
        {/* {data?.geographicalType} */}
        <Box sx={{ display: "flex" }}>
          <Box
            sx={{
              // p: 1,
              padding: "3px 5px",
              backgroundColor: "var(--mui-palette-primary-orange)",
              marginRight: "1rem",
              borderRadius: "6px",
              fontSize: ".7rem",
              fontWeight: "600",
              letterSpacing: "0.5px",
            }}
          >
            <Typography
              color="common.white"
              align="left"
              fontWeight="500"
              variant="h6"
              sx={{
                fontSize: "1rem",
              }}
            >
              {data.geographicalType}
            </Typography>
          </Box>
        </Box>

        <Box sx={styles.courseDetail}>
          <Box sx={styles.detailItem}>
            {/* < Box sx={styles.itemHeading}>learning Generation :</Box> */}
            {data?.learningGeneration?.map((gen, i) => {
              return (
                <React.Fragment key={gen?.genId}>
                  <Box sx={styles.itemHeading}>
                    Learning Generation :{gen?.generation}
                  </Box>
                  <Box sx={styles.itemValue}>
                    Voice : {gen?.gender}, Words Per Min :{" "}
                    {gen?.words_per_minute}
                  </Box>
                </React.Fragment>
              );
            })}
          </Box>
        </Box>
      </Box>
      <Box sx={styles.actionBtn}>
        <Link
          style={styles.actionBtnItem}
          component={RouterLink}
          to={`/speech-config/edit/${data?.id}`}
          title="Edit Grading"
        >
          <CreateIcon
            sx={{
              color: "var(--mui-palette-primary-button)",
              fontSize: "1.2rem",
            }}
          />
        </Link>
      </Box>
    </Box>
  );
}

const styles = {
  courseDetail: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    marginTop: "15px",
  },
  detailItem: {
    marginBottom: "10px",
  },
  itemHeading: {
    color: "var(--mui-palette-darkGrey-darkGrey100)",
    fontSize: "0.9rem",
    fontWeight: 600,
    marginBottom: "5px",
  },
  itemValue: {
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: "0.8rem",
    minHeight: "32px",
  },
  badge: {
    padding: "6px 10px",
    backgroundColor: "var(--mui-palette-primary-orange)",
    marginRight: "1rem",
    borderRadius: "6px",
    fontSize: ".7rem",
    fontWeight: "600",
    letterSpacing: "0.5px",
  },
  badgeGreen: {
    backgroundColor: "var(--mui-palette-primary-dark)",
    color: "var(--mui-palette-common-white)",
  },
  badgeOrange: {
    color: "var(--mui-palette-common-white)",
    backgroundColor: "var(--mui-palette-primary-orange)",
  },
  actionBtn: {
    textAlign: "right",
    position: "absolute",
    top: "10px",
    right: "10px",
    padding: "5px",
  },
  actionBtnItem: {
    marginLeft: "5px",
    marginRight: "5px",
    cursor: "pointer",
  },
};

export default SpeechConfigCard;
